<!--
   设计背景，打算后台用户中心全部使用弹窗展示，这就需要有一个统一的弹窗，因此定义了这样一个统一的弹窗专供用户中心访问。
   + 坑
     - 坑一：display mode
       当初设计 display mode 的时候想到的是每个单独的 $route 享有一个唯一的 display mode 用来控制一些控件的展示行为。但是 Dialog 现在打破
       了这个设计，因为一个 Dialog 实际上就是一个 $route，而它有自己的展示行为。现在就变成了，同一个页面中有两个 $route，那么就有两套 display
       mode 需要维护。这是导致 BUG HCF-175 和 HCF-177 在 Single Entity Page 中的 user center likes 页面中无法打开 Poppedup entity
       window 和在 Profile page 中的 popedup entity window 中无法点击 profile name 打开新窗口的原因。因此，这里的修复方式便是，当打开
       dialog 的时候，缓存当前 $route 中的 display mode 的值，关闭后，还原即可，然后各自使用了 dialog 的组件，自行设定自己 display mode
       即可。
-->
<template>
    <el-dialog
        :title="title"
        :visible.sync="isShow"
        :before-close="hide"
        :append-to-body="true"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
        :show-close="isShowCloseBtn"
        :modal="isModal"
        :top="top"
        lock-scroll
        :width="dialogWidth"
        center>
        <el-divider></el-divider>
        <div align="center" class="dialog-content-panel" :style="[contentStyle]">
            <slot></slot>
        </div>
        <!-- 最外层是实现 MyDialog 的 footer，内层的 footer 是实现 MyDialog 自己的 footer，见 Payment 的实现 -->
        <span slot="footer">
            <slot name="footer"></slot>
        </span>
    </el-dialog>
</template>

<script>
    import {isPhoneAgent, Styles} from "../../utils";

    export default {
        name: "MyDialog",
        props:{
            title: {
                type: String,
                default: '请添加标题'
            },
            hideCallback: {
                type: Function,
                default: () => {}
            },
            dialogWidth: {
                type: String,
                default: null
            },
            contentStyle: Object,
            isShowCloseBtn: {
                type: Boolean,
                default: true
            },
            isModal: {
                type: Boolean,
                default: true
            },
            top: {
                type: String,
                default: '8vh'
            }
        },
        data() {
            return {
                isShow: false
            }
        },
        methods:{
            show(){
                this.isShow = true;
                this.cachedDisplayMode = _.cloneDeep(this.$store.getters.getDisplayMode());
                console.log('my dialog show, this cached display mode', this.cachedDisplayMode);
                Styles.disableBodyScroll();
                // FIX for HCF327 - 手机端在用户中心喜欢/收藏的弹出 entity 页面中，点击 profile name 路由到 profile 页面，弹出窗口不关闭
                // 注意千万不要在 MyDialog 的生命周期方法 created/beforeDestroy 中监听，否则所有 user center 中的 Dialog 当前弹出的
                // 还是没有弹出的都会监听，导致报错！这里一定要确保只是在弹出的 Dialog 监听....
                if(isPhoneAgent()) {
                    this.$EventBus.$on('closepopups', () => {
                        this.hide();
                    });
                }
            },
            hide(){
                this.isShow = false;
                this.hideCallback(); // 回调子组件注册的 hide callback 方法。
                this.$store.commit('setDisplayMode', this.cachedDisplayMode);
                console.log('my dialog close, revert the display mode, the display mode:', this.$store.getters.getDisplayMode());
                Styles.enableBodyScroll();
                // FIX for HCF327
                if(isPhoneAgent()) this.$EventBus.$off('closepopups');
            }
        }
    }
</script>

<!--
  style 的相关说明：
    1. Dialog 的遮罩层是 Element ui 动态自动添加的，因此无法在这个 component 中单独的设置。因此只能在 App.vue 中统一设置（.v-modal）。
    2. 不要使用 scoped，否则 MyDialog 组件中的样式是不允许被覆盖的。
-->
<style scoped>

    /* 注意：即便是没有使用 el-dialog footer 的情况下，默认也要占用大概 20-30px 的高度，而我基本上没有使用 footer，因此设 0 */
    /deep/ .el-dialog__footer{
        padding: 0 0 0 0 !important;
    }

    .dialog-content-panel{
        /* overflow: auto; */ /* fix HCF-345：真机环境下，用户喜欢列表不能完全弹出 entity，是因为此时的 popup entity 的行为很诡异，它的父类节点不能有任何一个是 overflow: auto/scroll 的*/
        overflow: hidden; /* 因此设置为 hidden，由用户自己去定义 div 决定 overflow 的行为，并且 hidden 可以避免某些元素超过了 mydialog 的高度，比如 NoSignal 组件就有可能 */
        height: 560px;
    }

    /* PC screen */
    @media (min-width: 736px) {
        /deep/ .el-dialog{
            width: 700px;  /* 主页展示的最大宽度的一半 */
        }
        /* 如果使用了基于 flex 布局的 list 空间，那么这个时候，必须根据 dialog 的窗口大小来动态布局了 */
        /* 计算方式是，因为 el-dialog 默认有 padding left right 各 20px 的宽度，因此 -40，然后还有 10px 的微调，因此最终得到 650 */
        /deep/ .reactive-row{
            width: 650px;
        }
    }

    /* pad screen */
    @media (min-width: 540px) and (max-width: 735px) {
        /deep/ .el-dialog{
            width: 100%;
        }
        .dialog-content-panel{
            height: 400px;
        }
        /deep/ .reactive-row{
            width: 350px;
        }
    }

    /* mobile screen */
    @media (max-width: 540px) {
        /deep/ .el-dialog{
            width: 100%;  /* 主页展示的最大宽度的一半 */
        }
        /* 调整 el-dialog 的 padding */
        /deep/ .el-dialog--center .el-dialog__body{
            padding-left: 2px;
            padding-right: 2px;
        }
        /deep/ .reactive-row{
            width: 100%;
        }
    }

    /* ============ 设置 list wrapper 的响应式高度，list wrapper 目前由所有的 dialog 组件内部分页所用 ============ */
    /* ============ 注意 .list-wrap 有两种方式，一种是在 dialog 中自己定义的，一种是由 List.vue 定义的，都在这里覆盖 ============ */
    /deep/ .list-wrap{
        overflow-y: auto;  /* 只允许纵向 overflow，横向还是隐藏 */
        overflow-x: hidden;
        padding: 0 10px 0 10px;
        margin-top: 0px;
        /*border: 1px solid black;*/
        height: 560px;  /**/
    }

    /* normal phone screen */
    @media (min-width: 350px) and (max-width: 400px) {

        /deep/ .dialog-content-panel{
            height: 470px;
        }

        /deep/ .list-wrap{
            padding: 0 2px 0 2px;
            height: 468px;
        }
    }

    /* small phone screen */
    @media (max-width: 350px){

        /deep/ .dialog-content-panel{
            height: 430px;
        }

        /deep/ .list-wrap{
            padding: 0 2px 0 2px;
            height: 430px;
        }
    }

    /* 清除 menu 自己的 margin，使得 menu 可以适配外部容器 */
    .el-divider--horizontal{
        margin-top: -20px;
        margin-bottom: 20px;
    }

    /* ========= 统一设置如下的样式 ========= */
    /* 手机中的小屏幕 */
    @media (max-width: 374px) {
        /* 调整手机端 cell 两侧的 padding，默认是 10px 太大了 */
        /deep/ .el-table .cell{
            padding: 0 4px 0 4px !important;
        }

        /deep/ .el-dialog--center .el-dialog__body{
            padding: 2px 2px 2px 2px !important;
        }

        /deep/ .el-divider--horizontal{
            display: none !important;
        }
    }

    @media (max-width: 540px) {
        /* 调整手机端 cell 两侧的 padding，默认是 10px 太大了 */
        /deep/ .el-table .cell{
            padding: 0 8px 0 8px !important;
        }

        /deep/ .el-dialog--center .el-dialog__body{
            padding: 2px 2px 2px 2px !important;
        }

        /deep/ .el-divider--horizontal{
            display: none !important;
        }
    }

    /* ========= 统一设置如下的样式 end ========= */

</style>



// WEBPACK FOOTER //
// src/components/commons/MyDialog.vue